import ApiService from './api.service';

const BASE_URL = 'contract-requests';

/**
 * ContractRequestService — wrapper quanh BE module Đề Nghị Tạo HĐ.
 * BE docs: docs/features/be-023-025-contract-request-flow.md
 */
export const ContractRequestService = {
  /**
   * List có filter + pagination.
   * @param {Object} params - { status, storeId, saleId, customerName, fromDate, toDate, page, limit }
   */
  getAll(params) {
    return ApiService.query(BASE_URL, { params });
  },

  /**
   * Detail Đề nghị.
   * @param {string} id
   */
  getById(id) {
    return ApiService.query(`${BASE_URL}/${id}`);
  },

  /**
   * Tạo Đề nghị (status pending).
   * @param {Object} data CreateContractRequestDto
   */
  create(data) {
    return ApiService.post(BASE_URL, data);
  },

  /**
   * Update Đề nghị (chỉ pending).
   * @param {string} id
   * @param {Object} data UpdateContractRequestDto
   */
  update(id, data) {
    return ApiService.put(`${BASE_URL}/${id}`, data);
  },

  /**
   * Approve — Sale Admin/Manager.
   */
  approve(id) {
    return ApiService.post(`${BASE_URL}/${id}/approve`);
  },

  /**
   * Reject — body { reason } (min 10 ký tự).
   */
  reject(id, reason) {
    return ApiService.post(`${BASE_URL}/${id}/reject`, { reason });
  },

  /**
   * Cancel manual (Q2) — body { reason } (min 10 ký tự).
   */
  cancel(id, reason) {
    return ApiService.post(`${BASE_URL}/${id}/cancel`, { reason });
  },

  /**
   * Soft delete (chỉ pending/cancelled_manual).
   */
  remove(id) {
    return ApiService.delete(`${BASE_URL}/${id}`);
  },
};

export default ContractRequestService;
